import { useFormatters } from "@/lib/format";

interface CampaignStartDateCellProps {
  startDate: string | null;
}

export function CampaignStartDateCell({ startDate }: CampaignStartDateCellProps) {
  const { formatDate } = useFormatters();

  return (
    <span className="min-w-0 truncate text-ink" title={startDate ?? undefined}>
      {startDate ? formatDate(startDate) : "—"}
    </span>
  );
}
